module.exports = __webpack_public_path__ + "static/media/iphone_16.1876ed2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_16.jpg
// module id = 2140
// module chunks = 0